<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        //trigger: 'enter',
        skipDiacritics: true,
        //searchFn: mySearchFn,
        placeholder: 'Buscar en la tabla',
        //externalQuery: searchQuery
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: { field: 'sensor', type: 'asc' },
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 10,
        dropdownAllowAll: false,
        //setCurrentPage: 2,
        nextLabel: '',
        prevLabel: '',
        rowsPerPageLabel: 'Filas por pagina',
        ofLabel: 'de',
        pageLabel: 'pagina', // for 'pages' mode
        allLabel: 'Todas',
      }"
    >
      <template slot="table-row" slot-scope="props"> </template>
    </vue-good-table>
  </div>
</template>

<script>
import NotificationService from "@/services/NotificationService";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  name: "alarms-history-list",
  props: {
    selNode: String,
    selNodeDesc: String,
  },
  data() {
    return {
      localId: null,
      localDesc: null,
      rows: [],
      columns: [
        {
          label: "Sensor",
          thClass: "text-center",
          tdClass: "text-center",
          field: "sensor",
          hidden: true,
        },
        {
          label: "Estado",
          thClass: "text-center",
          tdClass: "text-center",
          field: "status",
        },
        {
          label: "Fecha activación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaCreacion",
        },
        {
          label: "Fecha cancelación",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaCancelacion",
        },
        {
          label: "Atendida por operario",
          thClass: "text-center",
          tdClass: "text-center",
          field: "atendida",
        },
        {
          label: "Fecha atendida",
          thClass: "text-center",
          tdClass: "text-center",
          field: "fechaAtendida",
        },
        {
          label: "idAlarm",
          field: "id",
          hidden: true,
        },
      ],
    };
  },
  components: {
    VueGoodTable,
  },
  computed: {},
  watch: {
    selNode: function (newVal, oldVal) {
      if (newVal != null) {
        this.localId = newVal;
      }
    },
    selNodeDesc: function (newVal, oldVal) {
      if (newVal != null) {
        this.localDesc = newVal;
        this.getNotificationHistory(newVal);
      }
    },
  },
  methods: {
    async getNotificationHistory(localDesc) {
        console.log("hola");
        console.log(localDesc)
      await NotificationService.getNotificationListBySensor(localDesc)
        .then((response) => {
          this.populateRows(response.data);
        })
        .catch((err) => {
          console.log("Error actualizando las opciones de notificacion");
          console.log(err);
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error guardando cambios",
            text:
              "Ha ocurrido un error guardando los cambios en el sistema de notificaciones",
            duration: 3000,
            speed: 1000,
          });
        });
    },
    // Rellenar las filas
    populateRows(rowList) {
      // Clean array before populate it
      this.rows = [];

      // Fill the array
      for (let i = 0; i < rowList.length; i++) {
        //Fill the struct
        let newData = {};

        newData = {
          sensor: rowList[i].sensor
            ? rowList[i].sensor.description
            : "Sin sensor asociado",
          status: rowList[i].estado,
          fechaCreacion: this.$moment(String(rowList[i].ts_activa))
            .local()
            .format("DD-MM-YYYY HH:mm:ss"),
          fechaCancelacion: rowList[i].ts_fin
            ? this.$moment(String(rowList[i].ts_fin))
                .local()
                .format("DD-MM-YYYY HH:mm:ss")
            : "-",
          atendida: rowList[i].atendida ? "Sí" : "No",
          fechaAtendida: rowList[i].ts_atendida
            ? this.$moment(String(rowList[i].ts_atendida))
                .local()
                .format("DD-MM-YYYY HH:mm:ss")
            : "-",
          id: rowList[i]._id,
          /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
          /*acciones: ''*/
        };

        //Push the data to the array
        this.rows.push(newData);
      }
    },
  },
  mounted() {
    if (this.localId == null) {
      this.localId = this.selNode;
    }
    if (this.localDesc == null) {
      this.localDesc = this.selNodeDesc;
      this.getNotificationHistory(this.localDesc);
    }
  },
};
</script>

<style scoped>
/* Estilo de la tabla */
table {
  border: 1px solid #dfe6ec;
}
table th {
  font-size: 0.77rem;
  border-right: 1px solid #dfe6ec;
}

table td {
  font-size: 0.77rem;
  border-right: 1px solid #dfe6ec;
}
.table th {
  padding: 0.3rem;
}

.table td {
  padding: 0.2rem;
}
/* COPIADO DE LA PAGINA DE BOOTSTRAP*/
.bd-callout {
  padding: 1rem;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid #e9ecef;
  border-left-width: 0.25rem;
  border-radius: 0.25rem;
  background: #fff;
}

.bd-callout-info {
  border-left-color: #5bc0de;
}

.bd-callout-warning {
  border-left-color: #f0ad4e;
}

.bd-callout-danger {
  border-left-color: #d9534f;
}

.bd-shadow {
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  transition: 0.3s;
}

.btn-primary {
  background-color: #83adeb;
  border-color: transparent;
  border-radius: 0.4rem;
  padding-bottom: 3px;
}

.btn-primary:hover {
  background-color: #4c88e4;
}

.btn-danger {
  background-color: #e45d86;
  border-color: transparent;
  border-radius: 0.4rem;
  padding-bottom: 3px;
  padding-top: 2px;
}

.btn-danger:hover {
  background-color: #e61e5a;
}

.custom-select {
  width: auto;
  zoom: 0.8;
}
</style>
